
import { AloDbUmbClasse } from '@/models/alodb/AloDbUmbClasse';
import { FilterBase } from '@/models/filter/FilterBase';

export interface IUmbClasseState {
    status:string
    umbClasses: Array<AloDbUmbClasse>
    modifiedAdmUmbClasse: AloDbUmbClasse
    originalAdmUmbClasse: AloDbUmbClasse
    umbClasseLoading: boolean
    adminFilter: FilterBase
}
  
const state:IUmbClasseState = { 
    status: '',
    umbClasses: [],
    modifiedAdmUmbClasse: new AloDbUmbClasse(),
    originalAdmUmbClasse: new AloDbUmbClasse(),
    umbClasseLoading:false,
    adminFilter: new FilterBase()
}
  
export default state